import { PaymentFormValues } from '@entities/payment'
import { Amount } from '@root/api/ump-ewallet'

export const initialPaymentFormValues: PaymentFormValues = {
  login: '',
  email: '',
  uid: '',
  uidPubg: '',
  id: '',
  playerId: '',
  zoneId: '',
  server: '',
  region: '',
  phone: '',
  amountInfo: {} as Amount,
  price: '350',
  priceDollar: '',
  serviceInfo: null,
  promocode: '',
}

export const MOCK_PAN_NUMBER = '2202252970539465'

export const CARD_NUMBER_LENGTH = 16
